import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import WebinarPageLayout from '@/components/pages/webinar/layout/webinar-page-layout';
import { Webinar } from '@/types/article-type';

export interface WebinarPageControllerProps {
    webinar: Webinar;
}

export const WebinarPageController = ({ webinar }: WebinarPageControllerProps) => {
    if (!webinar) {
        // todo: redirect to 404?
        return <>Webinar not found.</>;
    }

    return <WebinarPageLayout webinar={webinar} />;
};

export default withExceptionCatcher(WebinarPageController);
